/**
 * 组合完成的校验规则
 */
import {
  validatorEmail,
  validatorStringRange,
  validatorHttpAddr,
  validatorPhone,
  validatorPassword
} from '@/utils/validatorFrom.js'

export const validatorPhoneRule = (required = true, validator) => [
  {
    required: required,
    message: window.vm.$t('common.isNoEmpty'),
    trigger: 'blur'
  },
  {
    required: required,
    validator: validatorPhone,
    trigger: 'blur'
  },
  {
    required: required,
    validator,
    trigger: 'blur'
  }
]
export const validatorHttpAddrRule = (required = true, length = 100) => [
  {
    required: required,
    message: window.vm.$t('common.isNoEmpty'),
    trigger: 'blur'
  },
  {
    required: required,
    validator: validatorHttpAddr,
    trigger: 'blur'
  },
  {
    required: required,
    validator: validatorStringRange,
    trigger: 'blur',
    min: 0,
    max: length,
    message: window.vm.$t('common.validatorInputLength', {
      len: length
    })
  }
]

// 校验邮箱
export const validatorEmailRule = (required = true, validator) => [
  {
    required: required,
    message: window.vm.$t('common.isNoEmpty'),
    trigger: 'blur'
  },
  {
    required: required,
    validator: validatorEmail,
    trigger: 'blur'
  },
  {
    required: required,
    validator,
    trigger: 'blur'
  }
]

// 校验输入不为空，并且限制长度
export const validatorInputEmptyRule = (
  required = true,
  length = 100,
  validator
) => [
  {
    required: required,
    message: window.vm.$t('common.isNoEmpty'),
    trigger: 'blur'
  },
  {
    required: required,
    min: 0,
    max: length,
    validator: validatorStringRange,
    trigger: 'blur',
    message: window.vm.$t('common.validatorInputLength', {
      len: length
    })
  },
  {
    required: required,
    validator,
    trigger: 'blur'
  }
]

export const validatorPasswordRule = (
  required = true,
  length = 16,
  validator
) => [
  {
    required: required,
    message: window.vm.$t('common.isNoEmpty'),
    trigger: 'blur'
  },
  {
    required,
    min: 8,
    max: length,
    message: window.vm.$t('account.newPasswordLength'),
    trigger: 'blur'
  },
  {
    required,
    validator: validatorPassword,
    trigger: 'blur'
  },
  {
    required,
    validator,
    trigger: 'blur'
  }
]



// WEBPACK FOOTER //
// ./src/utils/validatorRule.js